// Regex email chặt hơn yup.string().email() mặc định (yup nhận cả "abc@gmailcom" thiếu TLD).
// Bắt buộc: local@domain.tld với tld >= 2 ký tự chữ (có dấu chấm trước phần đuôi).
export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/

export function validateEmail(email?: string | null): boolean {
  if (!email) {
    return false
  }
  return EMAIL_REGEX.test(email.trim())
}
